module.exports = __webpack_public_path__ + "img/icon_jackpot.fcc2dee9.svg";